import React, { useState } from 'react';
import '../unAuth/Contact.css';
import emailjs from '@emailjs/browser';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPills } from '@fortawesome/free-solid-svg-icons';
import { Navigate, useNavigate } from 'react-router-dom';

const RefPolicy = () => {

  return (
    <div className="contact-background">
      <div className="contact-container">
        <h1 className="contact-title">Refund Policy </h1>
            <div className="privacy-content">

<p>Effective Date: 07-06-2025</p>
<p>ClinicSync ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our software and services.</p>

<p>Returns
Our policy lasts 30 days. If 30 days have gone by since your purchase, unfortunately we can’t offer you a refund or exchange.

To be eligible for a return, your item must be unused and in the same condition that you received it. It must also be in the original packaging.

Several types of goods are exempt from being returned. Perishable goods such as food, flowers, newspapers or magazines cannot be returned. We also do not accept products that are intimate or sanitary goods, hazardous materials, or flammable liquids or gases.

Additional non-returnable items:
Gift cards
Downloadable software products
Some health and personal care items

To complete your return, we require a receipt or proof of purchase.

Please do not send your purchase back to the manufacturer.

There are certain situations where only partial refunds are granted: (if applicable)
Book with obvious signs of use
CD, DVD, VHS tape, software, video game, cassette tape, or vinyl record that has been opened.
Any item not in its original condition, is damaged or missing parts for reasons not due to our error.
Any item that is returned more than 30 days after delivery

Refunds (if applicable)
Once your return is received and inspected, we will send you an email to notify you that we have received your returned item. We will also notify you of the approval or rejection of your refund.
If you are approved, then your refund will be processed, and a credit will automatically be applied to your credit card or original method of payment, within a certain amount of days. 

Late or missing refunds (if applicable)
If you haven’t received a refund yet, first check your bank account again.
Then contact your credit card company, it may take some time before your refund is officially posted.
Next contact your bank. There is often some processing time before a refund is posted.
If you’ve done all of this and you still have not received your refund yet, please contact us at info@osiqsolutions.com
</p>

<p>
For questions or concerns, contact:
📧 Email: info@osiqsolutions.com
📍 Address: OSIQ SOLUTIONS, Hyderabad, India
</p>

            </div>
      </div>
    </div>
  );
};

export default RefPolicy;